import React from 'react';
const NotFound = (props) =>{
    return <div className="hero is-fullheight is-white">
    <section className="section">
        <center>
            <h1 className="title is-1 is-text-black is-center">404</h1>
            <h1 className="title is-1 is-text-black is-center">Page Not Found</h1>
        </center>
      
    </section>
    </div>
}
export default NotFound;


// WEBPACK FOOTER //
// ./src/components/themes/NotFound.js